import { render, staticRenderFns } from "./AlertEditPage.vue?vue&type=template&id=10f0bc3d&scoped=true&"
import script from "./AlertEditPage.vue?vue&type=script&lang=ts&"
export * from "./AlertEditPage.vue?vue&type=script&lang=ts&"
import style0 from "./AlertEditPage.vue?vue&type=style&index=0&id=10f0bc3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f0bc3d",
  null
  
)

export default component.exports